import React, {forwardRef, useState} from "react";
import {SearchIcon} from "@material-ui/data-grid";
import {InputBase, Paper} from "@material-ui/core";
import {useStyles} from "./FilterInput.styles";

// Create the component with forwardRef
const FilterInputComponent = forwardRef(({onChange, canExpand = false}, ref) => {
    const classes = useStyles();
    const [value, setValue] = useState('');

    const handleChange = (event) => {
        const newValue = event.target.value;
        setValue(newValue);
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <Paper className={classes.searchContainer} elevation={1}>
            <div className={classes.searchIcon}>
                <SearchIcon/>
            </div>
            <InputBase
                placeholder="Filter..."
                classes={{
                    root: classes.inputRoot,
                    input: canExpand ? classes.inputInputExpand : classes.inputInput,
                }}
                inputProps={{"aria-label": "search"}}
                value={value}
                onChange={handleChange}
                ref={ref}
            />
        </Paper>
    );
});

// Add display name to the component
FilterInputComponent.displayName = 'FilterInput';

// Export the component
export const FilterInput = FilterInputComponent;